<template>
    <div class="box">
        <el-form label-width="auto">

            <el-form-item label="标题">
                <el-input v-model="myObj.photo_classify_line_little_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="间距">
                <el-input-number v-model="myObj.photo_classify_line_little_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片宽">
                <el-input-number v-model="myObj.photo_classify_line_little_params.icon_width" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片高">
                <el-input-number v-model="myObj.photo_classify_line_little_params.icon_height" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="圆角">
                <el-input-number v-model="myObj.photo_classify_line_little_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.photo_classify_line_little_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="边框颜色">
                <el-color-picker v-model="myObj.photo_classify_line_little_params.border_color" />
                <span class="demonstration">{{ myObj.photo_classify_line_little_params.border_color }}</span>
            </el-form-item>

            <el-form-item label="边框粗细">
                <el-input-number v-model="myObj.photo_classify_line_little_params.border_width" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="内边距">
                <el-input-number v-model="myObj.photo_classify_line_little_params.item_padding" :min="0"></el-input-number>
            </el-form-item>

            <ComponentSource :component_source="obj.component_source" />

        </el-form>
    </div>
</template>

<script>

import ComponentSource from '../../ComponentSource/ComponentSource.vue';

export default {
    name: "PhotoClassifyLineLittleProp",
    components: {
        ComponentSource
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>